export default "__VITE_ASSET__B9qVuk$7__"